export const UPDATE_APP_DETAILS_LIST =  'UPDATE_APP_DETAILS_LIST';
export const UPDATE_LOADING_STATUS =  'UPDATE_LOADING_STATUS';
export const SET_LOADING_ERROR = 'SET_LOADING_ERROR';
export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';